import React, { useEffect, useState } from "react";
import Switch from '../../../../../../components/switch';
import StandAloneInput from "../../../../../../components/stand-alone-input";
import Select from 'react-select';
import { tableTemplates } from "../../../../../../utils/constants";

const ReportSettings = (props) => {

  const [editNPSRateTable, setEditNPSRateTable] = useState(true);
  const [editGenRateTable, setEditGenRateTable] = useState(true);
  const [editBillingRateTable, setEditBillingRateTable] = useState(true);
  const [editReportId, setEditReportId] = useState(true);
  const [tableOptions, setTableOptions] = useState([]);
  const [selectedTemplate, setSelected] = useState([]);

  useEffect(() => {
    setTableOptions(tableTemplates);
    let savedTemplate = props.tableTemplate;
    let selected = [];
    if (Array.isArray(savedTemplate)) {
      selected = tableOptions.filter(to => savedTemplate.includes(to.value));
    };
    setSelected(selected);
  }, [props.tableTemplate]);

  function handleChange(e) {
    setSelected(e);
    return onChange(e, "tableTemplate");
  };

  function onChange(val, field) {
    return props.onValueChange(val, field)
  };

  return (

    <>
      <div className="ec_setup_contact reg ">
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label><small>Table Template(s)</small></label>
            <Select
              options={tableOptions}
              onChange={handleChange}
              value={selectedTemplate}
              isMulti={true}
            >
            </Select>
          </div>
        </div>
      </div>
      <div className="ec_setup_contact reg ">
        {editNPSRateTable ? (
          <div className="reportId d-flex align-items-center justify-content-between">

            <div className="reportIdField repordIDCS_wd_100">
              <label><small>Rate Table Id - Non-Public School security guards</small></label>
              <p className="repordIDCS">
                {props.NPSRateTableId || "Please Enter NPS Rate Table Id"}
              </p>
            </div>

            <div className="reportIdField">
              <button className="btn reportBtn"
                onClick={() => setEditNPSRateTable(!editNPSRateTable)}
              >
                Edit
              </button>
            </div>


          </div>

        ) : (

          <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
            <div className="input_line ssD_fiels">
              <label><small>Rate Table Id - Non-Public School security guards</small></label>
              <StandAloneInput
                value={props.NPSRateTableId}
                change={e => onChange(e, "NPSRateTable")}
                placeholder="NPS Rate Table Id"
                id="rprt_inpt"
              ></StandAloneInput>

            </div>

            <button className="btn reportBtn"
              onClick={() => setEditNPSRateTable(!editNPSRateTable)}
            >
              Close
            </button>
          </div>
        )}
      </div>

      <div className="ec_setup_contact reg ">
        {editGenRateTable ? (
          <div className="reportId d-flex align-items-center justify-content-between">

            <div className="reportIdField repordIDCS_wd_100">
              <label><small>Rate table Id - NYC General form</small></label>
              <p className="repordIDCS">
                {props.GenRateTableId || "Please Enter General Rate Table Id"}
              </p>
            </div>

            <div className="reportIdField">
              <button className="btn reportBtn"
                onClick={() => setEditGenRateTable(!editGenRateTable)}
              >
                Edit
              </button>
            </div>


          </div>

        ) : (

          <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
            <div className="input_line ssD_fiels">
              <label><small>Rate table Id - NYC General form</small></label>
              <StandAloneInput
                value={props.GenRateTableId}
                change={e => onChange(e, "GenRateTable")}
                placeholder="General Form Rate Table Id"
                id="rprt_inpt"
              ></StandAloneInput>

            </div>

            <button className="btn reportBtn"
              onClick={() => setEditBillingRateTable(!editBillingRateTable)}
            >
              Close
            </button>
          </div>
        )}
      </div>
      <div className="ec_setup_contact reg ">
        {editBillingRateTable ? (
          <div className="reportId d-flex align-items-center justify-content-between">

            <div className="reportIdField repordIDCS_wd_100">
              <label><small>Rate table Id - Client Billing</small></label>
              <p className="repordIDCS">
                {props.BillingRateTableId || "Please Enter Rate Table Id for Client Billing"}
              </p>
            </div>

            <div className="reportIdField">
              <button className="btn reportBtn"
                onClick={() => setEditBillingRateTable(!editBillingRateTable)}
              >
                Edit
              </button>
            </div>
          </div>
        ) : (
          <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
            <div className="input_line ssD_fiels">
              <label><small>Rate table Id - Client Billing</small></label>
              <StandAloneInput
                value={props.BillingRateTableId}
                change={e => onChange(e, "BillingRateTable")}
                placeholder="Rate Table Id - Client Billing"
                id="rprt_inpt"
              ></StandAloneInput>
            </div>

            <button className="btn reportBtn"
              onClick={() => setEditBillingRateTable(!editBillingRateTable)}
            >
              Close
            </button>
          </div>
        )}
      </div>

      <div className="ec_setup_contact reg ">
        {editReportId ? (
          <div className="reportId d-flex align-items-center justify-content-between">

            <div className="reportIdField repordIDCS_wd_100">
              <label><small>Saved report id for compensation history</small></label>
              <p className="repordIDCS">
                {props.compHistoryReportId || "Please Enter Saved Report Id"}
              </p>
            </div>

            <div className="reportIdField">
              <button className="btn reportBtn"
                onClick={() => setEditReportId(!editReportId)}
              >
                Edit
              </button>
            </div>


          </div>

        ) : (

          <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
            <div className="input_line ssD_fiels">
              <label><small>Saved report id for compensation history</small></label>
              <StandAloneInput
                value={props.compHistoryReportId}
                change={e => onChange(e, "compHistReportId")}
                placeholder="Client-specific saved report id"
                id="rprt_inpt"
              ></StandAloneInput>

            </div>

            <button className="btn reportBtn"
              onClick={() => setEditReportId(!editReportId)}
            >
              Close
            </button>
          </div>
        )}
      </div>
      <div className="ec_setup_contact reg ">
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <p className="db">Use Retro?</p>
            <Switch
              onChange={e => onChange(e.target.checked, "useRetro")}
              id="useRetro"
              value={props.useRetro}
            />
          </div>

        </div>
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <p className="db">Combine EIN's? <small>(only when run by job)</small></p>
            <Switch
              onChange={e => onChange(e.target.checked, "combineEins")}
              id="combineEins"
              value={props.combineEins}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportSettings;
